import { useContext } from "react";

import { Trans, useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import AuthContext from "context/auth/authContext";

const GetEmailCode = () => {
    const { gray900 } = colors;

    const { user } = useContext(AuthContext);

    const { t } = useTranslation();

    return (
        <div
            css={css({
                "& > p": {
                    color: gray900,
                    fontSize: "14px",
                    fontWeight: "500",
                    lineHeight: "20px",
                    letterSpacing: "0.1px",
                    margin: "0",

                    "& > span": {
                        fontWeight: "600"
                    }
                },

                "& > p:first-of-type": {
                    wordBreak: "break-word"
                }
            })}
        >
            <p>
                <Trans
                    i18nKey="Security##2FA##get email code##title"
                    values={{ email: user?.email }}
                    components={{
                        1: <span />
                    }}
                />
            </p>

            <p>{t("Security##2FA##get email code##description modal")}</p>
        </div>
    );
};

export { GetEmailCode };
